import React from 'react';
import Link from 'next/link';
import { BiArrowBack, BiSearchAlt } from 'react-icons/bi';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const BlogNotFound = () => {
    const { t } = useTranslations();

    return (
        <section className="blog-not-found-section">
            <div className="blog-not-found__decoration blog-not-found__decoration--top" />
            <div className="blog-not-found__decoration blog-not-found__decoration--bottom" />
            
            <div className="container">
                <FadeInAnimation direction="up" delay={100}>
                    <div className="blog-not-found-card">
                        <div className="blog-not-found-card__icon">
                            <BiSearchAlt />
                        </div>
                        
                        <h1 className="blog-not-found-card__title">
                            {t('blog_not_found_title')}
                        </h1>
                        
                        <p className="blog-not-found-card__description">
                            {t('blog_not_found_description')}
                        </p>
                        
                        <Link href="/blog" className="blog-not-found-card__button">
                            <BiArrowBack />
                            <span>{t('blog_back_to_list')}</span>
                        </Link>
                    </div>
                </FadeInAnimation>
            </div>
        </section>
    );
};

export default BlogNotFound;
